import { atom } from "recoil";

import { AbstractShop } from "~/shared/shipping/abstract-shop.interface";

export const recoilStoreModalState = atom<boolean>({
  key: "recoilStoreModalState",
  default: false,
});

export const collectInStoreSelected = atom<boolean>({
  key: "collectInStoreSelected",
  default: false,
});

export const recoilSelectedStore = atom<AbstractShop>({
  key: "recoilSelectedStore",
  default: undefined,
});
